/* Inground winter covers hub and size pages: the finder bar, the size page's cover type chips (and the
   finder's ?type= arriving there), and the size row's arrows. The above ground script asks for a shape
   first and fills the size list from it; every inground cover we stock is a rectangle, so the size list
   is printed in the markup and the finder is one step shorter.
   docs/decisions/2026-09-22-inground-winter-covers-page.md */
(function () {
  if (window.__apsIgwc) return;
  window.__apsIgwc = true;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var sizes = null;
    var el = document.querySelector('[data-igwc-sizes]');
    if (el) { try { sizes = JSON.parse(el.textContent); } catch (e) { sizes = null; } }
    document.querySelectorAll('[data-igwc-finder]').forEach(function (f) {
      var sz = f.querySelector('[data-f=size]'), ty = f.querySelector('[data-f=type]');
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!sz.value || !sizes) return;
        var hit = sizes.filter(function (x) { return x.slug === sz.value; })[0];
        if (!hit) return;
        window.location.href = hit.url + (ty.value ? '?type=' + encodeURIComponent(ty.value) : '');
      });
    });
    document.querySelectorAll('[data-igwc-fil]').forEach(function (fil) {
      var sec = fil.closest('section');
      function press(k) {
        fil.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.k === k)); });
        sec.querySelectorAll('.wc-gi').forEach(function (g) { g.hidden = !!k && g.dataset.k !== k; });
      }
      fil.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) press(b.dataset.k); });
      var want = new URLSearchParams(window.location.search).get('type');
      if (want && fil.querySelector('button[data-k="' + want + '"]')) press(want);
    });
    function over() {
      document.querySelectorAll('[data-igwc-rail]').forEach(function (r) {
        var t = r.querySelector('.wc-track');
        r.classList.toggle('over', t.scrollWidth > t.clientWidth + 2);
      });
    }
    document.querySelectorAll('[data-igwc-rail]').forEach(function (r) {
      var t = r.querySelector('.wc-track');
      r.querySelector('.wc-arr.l').addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.8, behavior: 'smooth' }); });
      r.querySelector('.wc-arr.r').addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.8, behavior: 'smooth' }); });
      var on = t.querySelector('.on');
      if (on) t.scrollLeft = Math.max(0, on.offsetLeft - t.clientWidth / 2 + on.clientWidth / 2);
    });
    over();
    window.addEventListener('resize', over);
  });
})();
